const $$splitComponentImporter = () => import('/app/src/routes/booking/payment-result.$outcome.$session.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
// Monri return URL of a client booking. Our ids live in the path; the query
// string belongs to Monri and is ignored.
export const Route = createFileRoute("/booking/payment-result/$outcome/$session")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});